import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

interface ICircularProgress {
  value: number
  color: 'secondary' | 'primary' | 'inherit' | undefined
}

export default function CircularProgressWithLabel({ value, color }: ICircularProgress) {
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress variant="static" value={value} color={color} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="caption" component="div" color={color}>{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  )
}
